
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as UserRegisterIconComponent } from "./user-register-icon.svg";

export const UserRegisterIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <UserRegisterIconComponent {...props} />;
};
